import React      from 'react';
import classnames from 'classnames';

const name = (group, inputName) => {
  if (group === null || group === '') {
    return inputName;
  }
  return `${group}[${inputName}]`;
};

const TextInput = props => (
  <input
    type={props.type}
    id={props.inputId}
    className={classnames('form-control', { 'ignore-on-quote': props.ignoreOnQuote }, props.inputClassName)}
    name={name(props.groupName, props.name)}
    value={props.value}
    placeholder={props.placeholder}
    onChange={props.onChange}
    onBlur={props.onBlur}
    disabled={props.disabledInput}
    {...props.data} />
);

TextInput.defaultProps = {
  type         : 'text',
  groupName    : 'parameters',
  name         : '',
  ignoreOnQuote: false,
};

export default TextInput;
